import { coreClient as client } from '@app/helpers/requests/client';
import { getResponseData } from '@app/helpers/requests/bennieFetch';

export const fetchCompanyAccesses = () =>
  client.get(`/v1/companyAccesses`).then(response => getResponseData(response));

export const fetchUserType = () =>
  client.get(`/v1/currentUserType`).then(response => getResponseData(response));
